import { useMutation, useQueryClient } from "@tanstack/react-query";
import { forceDeleteLevel as apiForceDelete } from "../../api/apiLevels";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useForceDeleteLevel() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: forceDeleteLevel, isPending: isForceDelete } = useMutation({
        mutationFn: (id) => apiForceDelete(id),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["levels"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { forceDeleteLevel, isForceDelete };
}
